/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Cost_Centre_CodeInputs */

const en_reference_field_cost_centre_code = /** @type {(inputs: Reference_Field_Cost_Centre_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cdc code`)
};

/**
* | output |
* | --- |
* | "Cdc code" |
*
* @param {Reference_Field_Cost_Centre_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_cost_centre_code = /** @type {((inputs?: Reference_Field_Cost_Centre_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Cost_Centre_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_cost_centre_code(inputs)
});